import React from 'react';
import ASearchBar from 'antd-mobile/lib/search-bar';



export default class SearchBar extends ASearchBar {}